module.exports = __webpack_public_path__ + "media/images/stars-1d2546d23f093d1894ce93e74f3f6833.svg";